import React, { useState, useEffect, useRef } from 'react'
import SubNav from '../../../components/sub-nav';
import {
  Container,
  Heading,
  Select,
  Stack,
  InputGroup, Button, Input, InputRightElement, Spinner } from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons'
import { useToast } from '@chakra-ui/react'
import { user } from '../../../assets/auth';
import { styled } from 'styled-components';
import { colors } from '../../../styles/theme';
import { BsArrowRight } from 'react-icons/bs'
import { MdOutlineKeyboardArrowDown } from 'react-icons/md'
import { naira } from '../../../assets/dashboard/utils';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { increment, decrement } from '../../../store/reducers/loading';
import SearchableDropdown from '../../../components/SearchableDropdown';
import { CurrencyFormatter } from '../../../utils/common';


const Cable = () => {
  const loadingCount = useSelector((state) => state.loading.count);
  const isLoading = () => {

    // console.log(loadingCount);
    return loadingCount > 0;
  }
  const dispatch = useDispatch();


  const navigate = useNavigate();
  const toast = useToast()

  const [number, setNumber] = useState('')
  const [password, setPassword] = useState('')
  const [cables, setCables] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState('')
  const [cableTvId, setCableTvId] = useState('')
  const [cableBouquetId, setCableBouquetId] = useState('')
  const [smartCardNumber, setSmartCardNumber] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [verified, setVerified] = useState(false)
  const [reference, setReference] = useState('')
  const [bouquets, setBouquets] = useState([])
  const [amount, setAmount] = useState([])
  const [beneficiaries, setBeneficiaries] = useState([])
  const [showPassword, setShowPassword] = useState(false)
  const [selectedBeneficiaryId, setSelectedBeneficiaryId] = useState(null)

  


  const handleGetCableTv = async () => {
    try {
      dispatch(increment());
      const token = `Bearer ${Cookies.get('Token')}`
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/cable/get_tv`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
      });

      const data = await response.json();
      setCables(data.data.map(x => ({value: x.id, label: x.name}) ))
      

      dispatch(decrement());
    } catch (err) {
      dispatch(decrement());
      // Handle errors
      // console.log(err)
      toast({
          title: "Netork Error",
          status: 'error',
          description: "Check you internet connection",
          isClosable: true,
        })
    }
  }

  const verifyCableNumber = async () => {
    const token = `Bearer ${Cookies.get('Token')}`
    try {
      dispatch(increment());
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/cable/get_info`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
        body: JSON.stringify({
          bouquet_id: cableBouquetId,
          smart_card_no: smartCardNumber
        }), // Convert the form data to JSON
      });

      const data = await response.json();
      if (!data.status) {
        // console.log(data.status)
        toast({
          title: "An error occurred",
          status: 'error',
          description: data?.message,
          isClosable: true,
        })
      } else {
        setReference(data.data.reference_id)
        setCustomerName(data.data.customer)
        setVerified(true)
        setAmount(data.data.bouquet.price)
      }
      dispatch(decrement());
    } catch (err) {
      dispatch(decrement());
      // console.log(err)
      if (err.response && err.response.status === 401) {
       navigate("/auth/login");
      }
    }
  }

  const handlerChangeCableNumber = async (event) => {
    event.preventDefault();
    setVerified(false)
    const smartCardNumberS = event.target.value;
    setSmartCardNumber(smartCardNumberS);


  }

  const getBouquets = async (cableTvId) => {
    dispatch(increment())
    const token = `Bearer ${Cookies.get('Token')}`
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/cable/${cableTvId}/bouquets`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    });

    const data = await response.json();
    // console.log(data);
    setBouquets(data.data.map(x => ({value: x.id, label: `${x.name} (${CurrencyFormatter(x.price)})` }) ))
    dispatch(decrement())
  }

  const handleSelectedCableTv = async (selectedOption) => {
    setVerified(false);
    const selectedId = selectedOption;
    // console.log(selectedId)
    setCableTvId(selectedId)

    if (!selectedId) {
      return;
    }
    await getBouquets(selectedId);

  }

  const handleSelectedBouquet = async (selectedOption) => {
    setVerified(false);
    const selectedId = selectedOption;
    setCableBouquetId(selectedId)


  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!password) {
      return toast.error("please provide all values");
    }
    dispatch(increment())
    const token = `Bearer ${Cookies.get('Token')}`
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/cable/vend`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
        body: JSON.stringify({
          reference_id: reference,
          phone_number: number,
          payment_method: 'wallet',
          password: password,
        }),
      });

      if(response.status == 401)  {
        navigate("/auth/login");
      }
      const data = await response.json();
      dispatch(decrement());
      if(response.status > 300) {
        if(response.status == 500) {
          toast({
            title: "Something went wrong",
            status: 'error',
            description: "Please contact support",
            isClosable: true,
          })
        }
        toast({
          title: data.message,
          status: 'error',
          description: "",
          isClosable: true,
        })
        return;
      }
      if (!data.status) {
        // console.log(data.status)
        toast({
          title: "An error occurred",
          status: 'error',
          description: data?.message,
          isClosable: true,
        })
      } else {
        const msgToPass = "You cable purchase was successful!"
        navigate("/dashboard/success", { state: { type: 'cable', data: msgToPass, transaction: data.data } });

      }
    } catch (err) {
      // Handle errors
      dispatch(decrement());
      // console.log(err)
      toast({
          title: "Netork Error",
          status: 'error',
          description: "Check you internet connection",
          isClosable: true,
        })
    }

    // // console.log(user);
  };

  const handleGetBeneficiary = async () => {
    try {
      dispatch(increment());
      const token = `Bearer ${Cookies.get('Token')}`
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/cable/card_no`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
      });

      const data = await response.json();
      setBeneficiaries(data.data)

      dispatch(decrement());
    } catch (err) {
      dispatch(decrement());
      // console.log(err)
      if (err.response && err.response.status === 401) {
       navigate("/auth/login");
      }
    }
  }

  const handleSelectedBeneficiary = async (selectedOption) => {
  
    setVerified(false);
    let selectedBeneficiaryId = selectedOption;
    if(selectedBeneficiaryId == 0) return;
    if (!selectedBeneficiaryId || selectedBeneficiaryId.length < 1) return;
    let beneficiary = beneficiaries.filter(x => x.id == selectedBeneficiaryId)[0];
    // console.log(beneficiary);
    let cableTvId = beneficiary.bouquet?.cable_type?.id;
    getBouquets(cableTvId);
    setCableTvId(cableTvId);
    setSmartCardNumber(beneficiary.card_number);
    setSelectedBeneficiaryId(selectedBeneficiaryId);
    setCableBouquetId(beneficiary?.bouquet?.id);
  }

  const getBeneficiaryOptions = () => {
    let options = beneficiaries.map(item => {
      return {
        value: item.id,
        label: `${item?.bouquet?.cable_type?.name} ${item?.card_number} - ${item?.customer_name}`
      }
    });

    return [{value: 0, label: 'New beneficiary'},...options];
   
  }


  useEffect(() => {
    handleGetCableTv();
    handleGetBeneficiary();
  }, []);
  return (
    <div>
      <Wrapper>
        <SubNav title={'Cable TV'} />
        <Container maxW={{ base: 'sm', md: 'md', lg: 'lg' }} my='2rem'>
          <Heading fontSize={'24px'} fontWeight='700' fontFamily={'inter'} textAlign='center' mb={'1rem'}>Pay for you Cable bills</Heading>
          <form onSubmit={handleSubmit}>

            {/* ================ beneficiaries =========== */}
            <label>Select Beneficiary</label>
            <InputContainer style={{ margin: '1.2rem 0', justifyContent: 'space-between' }}>
              <SearchableDropdown 
              options={getBeneficiaryOptions()} 
              onSelect={handleSelectedBeneficiary} 
              defaultText={'Select Beneficiary'} 
              value={selectedBeneficiaryId}
              />
            </InputContainer>

            {/* ================ cable tv =========== */}
            <label>Select Cable Tv</label>
            <InputContainer style={{ margin: '1.2rem 0', justifyContent: 'space-between' }}>
              <SearchableDropdown 
              options={cables} 
              onSelect={handleSelectedCableTv} 
              defaultText={'Select Cable Tv'} 
              value={cableTvId}/>
            </InputContainer>

            {/* ================ bouquest =========== */}
            <label>Select bouquet</label>
            <InputContainer style={{ margin: '1.2rem 0', justifyContent: 'space-between' }}>
              <SearchableDropdown 
              options={bouquets} 
              onSelect={handleSelectedBouquet} 
              defaultText={'Select Bouquet'} 
              value={cableBouquetId}
              />
            </InputContainer>

            {/* ================ smart card =========== */}
            <label>Smart card number</label>
            <InputContainer style={{ margin: '1.2rem 0' }}>
              <input autocomplete="off" name={Math.random().toString(36).substr(2, 10)}
                style={{"flex": "1"}}
                type="text"
                value={smartCardNumber}
                onChange={handlerChangeCableNumber}
              />
            </InputContainer>

            {!verified 
              && 
              <Stack spacing={10} pt={2}>

              {!isLoading() ? <Button
                loadingText="Loading"
                size="lg"
                onClick={verifyCableNumber}
                bg={'blue.400'}
                color={'white'}
                _hover={{
                  bg: 'blue.500',
                }}
              >
                Continue <BsArrowRight style={{ fontSize: '22px', marginLeft: '.7rem', fontWeight: '600' }} />
              </Button>
                :
                <Button

                  size="lg"

                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}
                  disabled={true}


                >
                  <Spinner
                    height="10"
                    width="10"
                    radius="9"
                    color="white"
                    alignContent={'center'}


                  />
                </Button>

              }
              </Stack>
            }
            {verified && <>

              {/* ================ card number =========== */}
              <label>Smart card Name</label>
              <InputContainer style={{ margin: '1.2rem 0' }}>
                <input autocomplete="off" name={Math.random().toString(36).substr(2, 10)}
                style={{"flex": "1"}}
                  type="text"
                  value={customerName}
                />
              </InputContainer>

              {/* ================ Amount =========== */}
              <label>Amount</label>
              <InputContainer style={{ margin: '1.2rem 0' }}>
                <img src={naira} alt={'icon'} />
                <input autocomplete="off" name={Math.random().toString(36).substr(2, 10)}
                  type="text"
                  value={amount}
                />
              </InputContainer>

              {/* ================ payment option =========== */}
              <label>Pay with</label>
              <InputContainer style={{ margin: '1.2rem 0' }}>
                <Select variant={'unstyled'}>
                  <option value={'wallet'}>My Wallet </option>
                </Select>
              </InputContainer>

              {/* ================ password =========== */}
              <label>Password</label>
              <InputContainer style={{ margin: '1.2rem 0', justifyContent: 'space-between' }}>
                <InputGroup p={0} m={0}>
                  <Input 
                  style={{"flex": "1"}}
                    type={showPassword ? 'text' : 'password'} 
                    placeholder="Password"
                    value={password}
                    _focus={{
                      border: 'none',
                      outline: 'none',
                      background: 'transparent'
                    }}
                    onChange={(e) => setPassword(e.target.value)}
                    variant='unstyled'
                    required />
                  <InputRightElement h={'full'}>
                    <Button
                      variant={'ghost'}
                      _focus={{
                        border: 'none',
                        outline: 'none',
                        background: 'transparent'
                      }}
                      _hover={{
                        background: 'transparent'
                      }}
                      onClick={() => setShowPassword((showPassword) => !showPassword)}>
                      {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </InputContainer>

              <Stack spacing={10} pt={2}>
                {!isLoading() ? 
                <Button
                  loadingText="Loading"
                  size="lg"
                  type='submit'
                  border='none'
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}
                >
                  Continue <BsArrowRight style={{ fontSize: '22px', marginLeft: '.7rem', fontWeight: '600' }} />
                </Button>
                  :
                  <Button
                    size="lg"
                    bg={'blue.400'}
                    color={'white'}
                    border='none'
                    _hover={{
                      bg: 'blue.500',
                    }}
                    disabled={true}
                  >
                    <Spinner
                      height="10"
                      width="10"
                      radius="9"
                      color="white"
                      alignContent={'center'}
                    />
                  </Button>
                }
              </Stack>
            </>}
          </form>
        </Container>
      </Wrapper>
    </div>
  )
}

export default Cable

const Wrapper = styled.div`
    background: #F3F3F3;
    padding-bottom: 4rem;
`;

const InputContainer = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;

    height: 60px;
    
    border-radius: 12px;
    border: 1px solid ${colors.textColor};
    background: #F5F7FB;
    box-shadow: 0px 4px 120px 0px rgba(127, 135, 158, 0.10);
    
    padding: 8px 10px;
    margin-bottom: 1rem;
  
  h3 {
    background: rgba(66, 164, 217, .16);
    color: ${colors.primaryColor};
    border-radius: 15px;
    width: 55px;
    margin-right: .6rem;
    /* opacity: 0.16; */
    padding: 10px 14px;

    @media (max-width: 992px) {
      padding: 9px 12px;
    }

  }
  
  input {
    background: transparent;
  }
  input:focus {
    border: none;
    outline: none;
  }

  img {
    align-self: center;
    margin: 0 1rem;
  }

  svg {
    font-size: 18px;
    font-weight: 600;
  }
`;